import React, { useState, useEffect, useCallback } from "react";
import {
    Drawer,
    Button,
    Form,
    Checkbox,
    Input,
    Switch,
    List, Typography, Space
} from "antd";
import {
    QuestionCircleOutlined
} from "@ant-design/icons";
import { triggerNotification } from "../common/notify";
import InstancesDrawer from "./InstancesDrawer";
import apiHelpers from "./data";
import common_api from "../../config/common_api";
import { useAuth } from "../UserAuth/AuthContext";




const initialData = [];

const AttributeDrawer = ({ visible, onClose, setisloader, onProductCreate, attrdata }) => {
    const [form] = Form.useForm();
    const [isExpanded, setIsExpanded] = useState(false);
    const [bundleTitle, setBundleTitle] = useState("Attributes");
    const [data, setData] = useState(attrdata);
    const options = ['Simple', 'KitProducts', 'BundleProducts', 'Variants'];
    const [checkedList, setCheckedList] = useState(options);
    const [items, setItems] = useState(initialData);
    const [editIndex, setEditIndex] = useState(null);
    const [editText, setEditText] = useState("");
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [newAttrValue, setNewAttrValue] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const { userData } = useAuth();
    const [isMultiValue, setIsMultiValue] = useState(data.max_size > 1);



    useEffect(() => {
        const fetchData = async () => {
            form.setFieldsValue({
                key: data.id,
                attribute_id: data.id,
                attribute_name: data.attribute_name,
                attribute_key: data.attribute_key,
                attribute_element_type: data.attribute_element_type,
                max_size: data.max_size,
                values_data: data.values_data,
            });

            // Extract initial values from values_data
            const extractedValues = data.values_data?.map(v => v.values) || [];

            setItems(extractedValues); // this will replace your static initialData
        };

        if (attrdata && visible) {
            fetchData();
            setData(attrdata);
            setBundleTitle(attrdata.attribute_name || "New Simple Product");
        }
    }, [attrdata, visible]);

    const openDrawer = useCallback(() => {
        setDrawerVisible(true)
    })
    const closeDrawer = () => setDrawerVisible(false);

    const isAllChecked = checkedList.length === options.length;
    const isIndeterminate = checkedList.length > 0 && checkedList.length < options.length;
    const onChange = (list) => {
        if (list.includes('All')) {
            if (checkedList.length === options.length) {
                setCheckedList([]);
            } else {
                setCheckedList(options);
            }
        } else {
            setCheckedList(list);
        }
    };




    const openNotification = () => {
        triggerNotification({
            type: 'error',
            title: 'Form incomplete!',
            message: "Please fix all errors before saving.",
        });
    };


    const handleEdit = (index) => {
        setEditIndex(index);
        setEditText(items[index]);
    };

    const handleDelete = (index) => {
        const newItems = [...items];
        newItems.splice(index, 1);
        setItems(newItems);
        setEditIndex(null);
    };

    const handleSave = () => {
        const newItems = [...items];
        newItems[editIndex] = editText;
        setItems(newItems);
        setEditIndex(null);
    };

    const handleCancel = () => {
        setEditIndex(null);
        setEditText("");
    };

    const addNewValue = async () => {
        const trimmedValue = newAttrValue.trim();
        try {
            await form.validateFields();
        } catch (err) {
            triggerNotification({ type: "error", message: "Please fix all errors before saving." });
            return;
        }

        if (!trimmedValue) {
            triggerNotification({ type: "error", message: "Value cannot be empty." });
            return;
        }

        setItems([...items, trimmedValue]);
        setNewAttrValue("");

        const updatedValuesData = {
            "frontend_attribute_id": data.id,
            "store_id": 5,
            "values": trimmedValue,
        };

        setisloader(true);
        const responsedata = await common_api.add_attribute_value(updatedValuesData);

        if (responsedata) {
            triggerNotification(responsedata);
        }
        setisloader(false);
    };

    const handleSaveAndPublish = async (val) => {
        if (errorMsg !== "") {
            triggerNotification({
                type: 'error',
                title: 'Error!',
                message: errorMsg,
            });
            return 1
        }


        const maxSize = form.getFieldValue("max_size") || data.max_size;
        const attrKey = data.attribute_key;
        const getPrimaryRegex = `^${attrKey}_([1-9]|[1-9][0-9])|${maxSize}$`
        const updatedAttr = {
            id: data.id,
            data: {
                attribute_label: data.attribute_name,
                attribute_key: attrKey,
                attri_pattern: getPrimaryRegex,
                max_size: maxSize
            }
        };
        setisloader(true);
        let responsedata = await common_api.update_attribute(updatedAttr);

        if (responsedata) {
            await onProductCreate();
            triggerNotification(responsedata);
        }
        setisloader(false);
        onClose()
    };
    return (
        <>
            <Drawer className={`DrawerBox ${data.attribute_element_type === "dropdown" ? "DrawerBoxExpanded" : ""}`}
                title={bundleTitle}
                width={data.attribute_element_type === "dropdown" ? 'calc(100% - 256px)' : 600}
                onClose={onClose}
                open={visible}

                extra={
                    <>
                        {userData.data?.access !== "ALL" || data.attribute_element_type !== "dropdown" && errorMsg === "" && (
                            <div className="DrawerButtonBox">
                                <Button type="primary" onClick={handleSaveAndPublish}>
                                    Save & Publish
                                </Button>
                            </div>
                        )}

                    </>
                }
            >
                <Form className="AttrForm" layout="vertical" form={form}>
                    <div className={`AttrFlexItemBox ${data.attribute_element_type === "dropdown" ? "ExpandedFlex" : ""}`}>
                        <div className={` ${data.attribute_element_type === "dropdown" ? "w-50" : ""}`} >
                            <div className="BoxHeader">
                                <h2>Attribute Settings</h2>
                            </div>
                            <Form.Item
                                label={
                                    <span>
                                        Attribute Name&nbsp;
                                    </span>
                                }
                                name="attribute_name"
                                rules={[{ required: true, message: "Please Enter Attrbute Name" }]}
                            >
                                <Input placeholder="Enter Attribute Name" disabled maxLength={250}/>
                            </Form.Item>
                            <Form.Item
                                label={
                                    <span>
                                        Attribute Type&nbsp;
                                    </span>
                                }
                                name="attribute_element_type"
                                rules={[{ required: true, message: "Please Enter a Attribute Type" }]}
                            >
                                <Input placeholder="Enter Attribute Type" disabled />
                            </Form.Item>
                            {data.attribute_element_type !== "dropdown" && (
                                <>
                                    <Form.Item  >
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Switch defaultChecked={data.max_size > 1} disabled
                                                onChange={(checked) => setIsMultiValue(checked)}
                                            />
                                            <span style={{ marginLeft: 8 }}>Multi Value</span>
                                        </div>
                                    </Form.Item>

                                    <Form.Item
                                        label={
                                            <span>
                                                Max Values&nbsp;

                                            </span>
                                        }
                                        name="max_size"
                                        rules={[
                                            {
                                                required: true,
                                                validator: (_, value) => {
                                                    setErrorMsg("")
                                                    if (value === undefined || value === null || value === "") {
                                                        setErrorMsg(`Please Enter Max Values`)
                                                        return Promise.reject(
                                                            new Error(`Please Enter Max Values`)
                                                        );
                                                    }
                                                    else if (value < data.max_size) {
                                                        setErrorMsg(`Max Values must be at least ${data.max_size}`)
                                                        return Promise.reject(
                                                            new Error(`Max Values must be at least ${data.max_size}`)
                                                        );
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },
                                            // { required: true, message: "Please Enter Max Values" }
                                        ]}
                                    >
                                        <Input type="number" min={data.max_size} placeholder="Enter Max Values" />
                                    </Form.Item>
                                    {/* )} */}
                                </>
                            )}
                            <Form.Item label="Product Mapping">
                                <Checkbox
                                    indeterminate={isIndeterminate}
                                    onChange={(e) => {
                                        setCheckedList(e.target.checked ? options : []);
                                    }}
                                    checked={isAllChecked} disabled
                                >
                                    All
                                </Checkbox>
                                <Checkbox.Group disabled
                                    options={options}
                                    value={checkedList}
                                    onChange={setCheckedList}
                                    style={{ display: "flex", flexDirection: "column", marginTop: 0 }}
                                />
                            </Form.Item>
                        </div>

                        {data.attribute_element_type === "dropdown" && (
                            <>
                                <div className="border-left"></div>
                                <div className={`w-50 Attribute-Values-box`}>
                                    <div className="BoxHeader">
                                        <h2>Attribute Values</h2>
                                    </div>
                                    <div className={``}>
                                        <List
                                            bordered={false}
                                            dataSource={items}
                                            renderItem={(item, index) => {
                                                const isEditing = index === editIndex;
                                                return (
                                                    <List.Item
                                                        style={{
                                                            background: isEditing ? "#e6f4ff" : undefined,
                                                            transition: "background 0.3s",
                                                        }}
                                                    >
                                                        <div style={{ flex: 1 }}>
                                                            {isEditing ? (
                                                                <Input
                                                                    value={editText}
                                                                    onChange={(e) => setEditText(e.target.value)}
                                                                    style={{ width: "100%" }}
                                                                />
                                                            ) : (
                                                                <Space direction="vertical" size={0}>
                                                                    <Typography.Text>{item}</Typography.Text>
                                                                </Space>
                                                            )}
                                                        </div>
                                                    </List.Item>
                                                );
                                            }}
                                        />
                                        {userData?.data?.access === "ALL" && (
                                            <Form.Item
                                                className="NewAttributeValue"
                                                label={
                                                    <span>
                                                        New Attribute Value&nbsp;

                                                    </span>
                                                }
                                                name="AttributeValue"
                                                rules={[
                                                    {
                                                        required: true,
                                                        validator: (_, value) => {
                                                            if (!value) {
                                                                return Promise.reject(new Error("Please Enter Attribute Value"));
                                                            }
                                                            if (value.trim() === "") {
                                                                return Promise.reject(new Error("Attribute Value cannot be empty or just spaces"));
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    },
                                                ]}
                                            >
                                                <Space.Compact style={{ width: '100%' }}>
                                                    <Input
                                                        placeholder="Enter Attribute Value"
                                                        value={newAttrValue}
                                                        onChange={(e) => setNewAttrValue(e.target.value)}
                                                        maxLength={50}
                                                    />
                                                    <Button
                                                        type="primary"
                                                        onClick={() => {
                                                            addNewValue()
                                                        }}
                                                    >
                                                        Add
                                                    </Button>
                                                </Space.Compact>
                                            </Form.Item>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>


                </Form>
            </Drawer>
        </>
    );
};

export default AttributeDrawer;
